var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "modal fade",
      staticStyle: { overflow: "hidden", "z-index": "2000" },
      attrs: { id: _vm.modalId, "data-backdrop": "static" }
    },
    [
      _c(
        "div",
        { staticClass: "modal-dialog modal-xs", attrs: { role: "document" } },
        [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-header" }, [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.card.name + " - " + _vm.$t("txtSharedWith")) +
                  "\n                "
              ),
              _c(
                "button",
                {
                  staticClass: "close",
                  attrs: {
                    type: "button",
                    "data-toggle": "modal",
                    "data-target": "#" + _vm.modalId
                  },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.close.apply(null, arguments)
                    }
                  }
                },
                [_vm._v("×")]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-body" }, [
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-6 container" },
                  [
                    _c("div", { staticClass: "row" }, [
                      _c("b", [
                        _vm._v(" " + _vm._s(_vm.$t("txtSharedWith")) + " ")
                      ])
                    ]),
                    _vm._v(" "),
                    _vm.alreadySharedWith.length
                      ? [
                          _c(
                            "ul",
                            { staticClass: "row list-group w-100" },
                            _vm._l(_vm.alreadySharedWith, function(account) {
                              return _c(
                                "li",
                                {
                                  key: account.id,
                                  staticClass: "list-group-item ptr p-1 px-2",
                                  on: {
                                    click: function($event) {
                                      return _vm.remove(account)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(account.name) +
                                      "\n                                "
                                  )
                                ]
                              )
                            }),
                            0
                          )
                        ]
                      : [
                          _c("div", { staticClass: "row" }, [
                            _vm._v(
                              "\n                                " +
                                _vm._s("(" + _vm.$t("txtEmpty") + ")") +
                                "\n                            "
                            )
                          ])
                        ]
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-6 container" },
                  [
                    _c("div", { staticClass: "row" }, [
                      _c("b", [_vm._v(_vm._s(_vm.$t("txtAvailable")))])
                    ]),
                    _vm._v(" "),
                    _vm.available.length
                      ? [
                          _c(
                            "ul",
                            { staticClass: "row list-group w-100" },
                            _vm._l(_vm.available, function(account) {
                              return _c(
                                "li",
                                {
                                  key: account.id,
                                  staticClass: "list-group-item ptr p-1 px-2",
                                  on: {
                                    click: function($event) {
                                      return _vm.add(account)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(account.name) +
                                      "\n                                "
                                  )
                                ]
                              )
                            }),
                            0
                          )
                        ]
                      : [
                          _c("div", { staticClass: "row" }, [
                            _vm._v(
                              "\n                                " +
                                _vm._s("(" + _vm.$t("txtEmpty") + ")") +
                                "\n                            "
                            )
                          ])
                        ]
                  ],
                  2
                )
              ])
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c("board-select", {
        ref: "boardselect",
        attrs: { state: _vm.state },
        on: { selected: _vm.selfShardBoardSelected }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }